var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._b({attrs:{"outlined":"","dense":"","hide-details":"","clearable":"","prepend-inner-icon":"mdi-paperclip","prepend-icon":null,"loading":_vm.loading},on:{"change":_vm.choose}},'v-file-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }